import { useCallback } from 'react'

import { TeamMemberRole } from '@api'
import { useUnit } from 'effector-react'

import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button.tsx'
import { SearchInput } from '@/components/ui/search-input.tsx'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { $account } from '@/models/account.ts'
import { openDialog } from '@/models/dialogs.ts'

interface HeaderButtonsProps {
  setFilter: (filter: string) => void
}

export const HeaderButtons = ({ setFilter }: HeaderButtonsProps) => {
  const account = useUnit($account)

  const handleNewCreatorPress = useCallback(() => {
    openDialog({
      type: DIALOG_TYPE.ADD_CREATOR,
    })
  }, [])

  return (
    <div className="flex items-center gap-2">
      <SearchInput
        placeholder="Enter Name"
        onInputChange={setFilter}
      />
      {account?.memberRole === TeamMemberRole.LEADER && (
        <Button
          onClick={handleNewCreatorPress}
          className="gap-1"
        >
          <PlusIcon />
          <span className="inline">Add Creator</span>
        </Button>
      )}
    </div>
  )
}
